module.exports = __webpack_public_path__ + "img/vps9.0ac473c.png";